/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AccountConfirmEmailCommand } from '../models/account-confirm-email-command';
import { AccountConfirmEmailResult } from '../models/account-confirm-email-result';
import { AccountForgotPasswordCommand } from '../models/account-forgot-password-command';
import { AccountGetRefreshTokenCommand } from '../models/account-get-refresh-token-command';
import { AccountGetRefreshTokenResult } from '../models/account-get-refresh-token-result';
import { AccountLoginCommand } from '../models/account-login-command';
import { AccountLoginResult } from '../models/account-login-result';
import { AccountRegistrationCommand } from '../models/account-registration-command';
import { AccountRegistrationResult } from '../models/account-registration-result';
import { AccountResetPasswordCommand } from '../models/account-reset-password-command';
import { AccountResetPasswordResult } from '../models/account-reset-password-result';
import { AccountTwoFactorVerifyCommand } from '../models/account-two-factor-verify-command';
import { AccountTwoFactorVerifyResult } from '../models/account-two-factor-verify-result';

@Injectable({
  providedIn: 'root',
})
export class AccountsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation registration
   */
  static readonly RegistrationPath = '/api/Accounts/Registration';

  /**
   * Registers a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registration()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registration$Response(params?: {
    context?: HttpContext
    body?: AccountRegistrationCommand
  }
): Observable<StrictHttpResponse<AccountRegistrationResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.RegistrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountRegistrationResult>;
      })
    );
  }

  /**
   * Registers a user.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `registration$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  registration(params?: {
    context?: HttpContext
    body?: AccountRegistrationCommand
  }
): Observable<AccountRegistrationResult> {

    return this.registration$Response(params).pipe(
      map((r: StrictHttpResponse<AccountRegistrationResult>) => r.body as AccountRegistrationResult)
    );
  }

  /**
   * Path part for operation login
   */
  static readonly LoginPath = '/api/Accounts/Login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `login()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  login$Response(params?: {
    context?: HttpContext
    body?: AccountLoginCommand
  }
): Observable<StrictHttpResponse<AccountLoginResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.LoginPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountLoginResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `login$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  login(params?: {
    context?: HttpContext
    body?: AccountLoginCommand
  }
): Observable<AccountLoginResult> {

    return this.login$Response(params).pipe(
      map((r: StrictHttpResponse<AccountLoginResult>) => r.body as AccountLoginResult)
    );
  }

  /**
   * Path part for operation getClaims
   */
  static readonly GetClaimsPath = '/api/Accounts/GetClaims';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClaims()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClaims$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
[key: string]: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.GetClaimsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        [key: string]: string;
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClaims$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClaims(params?: {
    context?: HttpContext
  }
): Observable<{
[key: string]: string;
}> {

    return this.getClaims$Response(params).pipe(
      map((r: StrictHttpResponse<{
[key: string]: string;
}>) => r.body as {
[key: string]: string;
})
    );
  }

  /**
   * Path part for operation forgotPassword
   */
  static readonly ForgotPasswordPath = '/api/Accounts/ForgotPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forgotPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword$Response(params?: {
    context?: HttpContext
    body?: AccountForgotPasswordCommand
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.ForgotPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `forgotPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  forgotPassword(params?: {
    context?: HttpContext
    body?: AccountForgotPasswordCommand
  }
): Observable<void> {

    return this.forgotPassword$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation resetPassword
   */
  static readonly ResetPasswordPath = '/api/Accounts/ResetPassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetPassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resetPassword$Response(params?: {
    context?: HttpContext
    body?: AccountResetPasswordCommand
  }
): Observable<StrictHttpResponse<AccountResetPasswordResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.ResetPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountResetPasswordResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resetPassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  resetPassword(params?: {
    context?: HttpContext
    body?: AccountResetPasswordCommand
  }
): Observable<AccountResetPasswordResult> {

    return this.resetPassword$Response(params).pipe(
      map((r: StrictHttpResponse<AccountResetPasswordResult>) => r.body as AccountResetPasswordResult)
    );
  }

  /**
   * Path part for operation confirmEmail
   */
  static readonly ConfirmEmailPath = '/api/Accounts/ConfirmEmail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  confirmEmail$Response(params?: {
    context?: HttpContext
    body?: AccountConfirmEmailCommand
  }
): Observable<StrictHttpResponse<AccountConfirmEmailResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.ConfirmEmailPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountConfirmEmailResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `confirmEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  confirmEmail(params?: {
    context?: HttpContext
    body?: AccountConfirmEmailCommand
  }
): Observable<AccountConfirmEmailResult> {

    return this.confirmEmail$Response(params).pipe(
      map((r: StrictHttpResponse<AccountConfirmEmailResult>) => r.body as AccountConfirmEmailResult)
    );
  }

  /**
   * Path part for operation twoFactorVerify
   */
  static readonly TwoFactorVerifyPath = '/api/Accounts/TwoFactorVerify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `twoFactorVerify()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  twoFactorVerify$Response(params?: {
    context?: HttpContext
    body?: AccountTwoFactorVerifyCommand
  }
): Observable<StrictHttpResponse<AccountTwoFactorVerifyResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.TwoFactorVerifyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountTwoFactorVerifyResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `twoFactorVerify$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  twoFactorVerify(params?: {
    context?: HttpContext
    body?: AccountTwoFactorVerifyCommand
  }
): Observable<AccountTwoFactorVerifyResult> {

    return this.twoFactorVerify$Response(params).pipe(
      map((r: StrictHttpResponse<AccountTwoFactorVerifyResult>) => r.body as AccountTwoFactorVerifyResult)
    );
  }

  /**
   * Path part for operation getRefreshToken
   */
  static readonly GetRefreshTokenPath = '/api/Accounts/GetRefreshToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRefreshToken()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getRefreshToken$Response(params?: {
    context?: HttpContext
    body?: AccountGetRefreshTokenCommand
  }
): Observable<StrictHttpResponse<AccountGetRefreshTokenResult>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.GetRefreshTokenPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AccountGetRefreshTokenResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRefreshToken$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getRefreshToken(params?: {
    context?: HttpContext
    body?: AccountGetRefreshTokenCommand
  }
): Observable<AccountGetRefreshTokenResult> {

    return this.getRefreshToken$Response(params).pipe(
      map((r: StrictHttpResponse<AccountGetRefreshTokenResult>) => r.body as AccountGetRefreshTokenResult)
    );
  }

  /**
   * Path part for operation revokeToken
   */
  static readonly RevokeTokenPath = '/api/Accounts/RevokeToken';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `revokeToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.RevokeTokenPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `revokeToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  revokeToken(params?: {
    context?: HttpContext
  }
): Observable<void> {

    return this.revokeToken$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation isPro
   */
  static readonly IsProPath = '/api/Accounts/IsPro';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `isPro()` instead.
   *
   * This method doesn't expect any request body.
   */
  isPro$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, AccountsService.IsProPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `isPro$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  isPro(params?: {
    context?: HttpContext
  }
): Observable<boolean> {

    return this.isPro$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
